export enum CredentialsTokenTypeEnum {
  Static = 'static',
  Rotating = 'rotating'
}
